import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrentUserDto } from '@platform/auth/current-user.model';

import { environment } from '@environments/environment';

import { PostUserDto, PutUserProfileDto, UserDto, UserOverviewDto, UserProfileDto } from './user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public getUserP: any;

  constructor(private http: HttpClient) {}

  public getActiveUsers(): Observable<UserDto[]> {
    return this.http.get<UserDto[]>(`${environment.apiUrl}/users`);
  }

  public getUserOverview(): Observable<UserOverviewDto[]> {
    return this.http.get<UserOverviewDto[]>(`${environment.apiUrl}/users/overview`);
  }

  public createUser(user: PostUserDto): Observable<UserDto> {
    let culture = 'de-CH';
    if (user.language === 'English') {
      culture = 'en';
    }

    return this.http.post<UserDto>(`${environment.apiUrl}/users?culture=${culture}`, user);
  }

  public getUserOrganizationUnits(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiUrl}/users/organization-units`);
  }

  public getUserProfile(userId: string): Observable<UserProfileDto> {
    return this.http.get<UserProfileDto>(`${environment.apiUrl}/users/${userId}`);
  }

  public putUserProfile(userId: string, userProfile: PutUserProfileDto): Observable<UserProfileDto> {
    return this.http.put<UserProfileDto>(`${environment.apiUrl}/users/${userId}`, userProfile);
  }

  public addUserDeputy(userId: string, deputyId: string): Observable<UserProfileDto> {
    return this.http.post<UserProfileDto>(`${environment.apiUrl}/users/${userId}/deputies/${deputyId}`, null);
  }

  public removeUserDeputy(userId: string, deputyId: string): Observable<UserProfileDto> {
    return this.http.delete<UserProfileDto>(`${environment.apiUrl}/users/${userId}/deputies/${deputyId}`);
  }

  public postProfilePicture(userId: string, file: File): Observable<CurrentUserDto> {
    let formData: FormData = new FormData();
    if (file === null) {
      formData = null!;
    } else {
      formData.append('file', file, file.name);
    }
    return this.http.post<CurrentUserDto>(`${environment.apiUrl}/users/${userId}/profile-picture`, formData);
  }

  public resendWelcomeMail(userId: string): Observable<UserProfileDto> {
    return this.http.post<UserProfileDto>(`${environment.apiUrl}/users/${userId}/resend-welcome-mail`, null);
  }

  public getCurrentUserRepresenteeIds(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiUrl}/users/current/representee-ids`);
  }
}
